import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import * as Links from "../../lib/links";
import PaymentOverlay from "../Payment";

export default function Menu() {
    const { t } = useTranslation();

    const [isMenuShowing, setIsMenuShowing] = React.useState();

    const onMenuShowChange = () => {
        setIsMenuShowing(!isMenuShowing);
    };

    function isActive(link, match, location) {
        if (link.active) {
            for (const firstPiece of link.active) {
                if (location.pathname.indexOf(`/${firstPiece}`) === 0) {
                    return true;
                }
            }
        }

        return location.pathname.indexOf(`/${link.route.split("/")[1]}`) === 0;
    }

    const links = [
        { route: Links.Dashboard(), active: ["dashboard", "website"], text: t("Dashboard") },
        { route: Links.Subscription(), text: t("Subscription") },
        { route: Links.Account(), text: t("Account") },
        { route: Links.Help(), text: t("Help") },
        { route: Links.Logout(), text: t("Logout") },
    ];

    let CNMenu = ["menu"];
    let CNMenuBtn = ["menu-btn"];
    let CNMenuLogo = ["panel-menu-logo"];
    isMenuShowing && CNMenu.push("active");
    isMenuShowing && CNMenuBtn.push("active");
    isMenuShowing && CNMenuLogo.push("active");
    CNMenuLogo = CNMenuLogo.join(" ");
    CNMenuBtn = CNMenuBtn.join(" ");
    CNMenu = CNMenu.join(" ");

    return (
        <>
            <PaymentOverlay />

            <div className="panel-menu">
                <div className={CNMenuLogo}>
                    <NavLink to="/">pgbldr.com</NavLink>
                </div>

                <nav className="panel-menu-burger">
                    <div className="menu-burger-container">
                        <header onClick={onMenuShowChange}>
                            <div className={CNMenuBtn}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </header>

                        <div className={CNMenu}>
                            <div className="panel-menu-burger-links">
                                {links.map(link => (
                                    <NavLink key={link.route} to={link.route} isActive={isActive.bind(null, link)}>
                                        {link.text}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </nav>

                <nav className="panel-menu-links">
                    {links.map(link => (
                        <NavLink key={link.route} to={link.route} isActive={isActive.bind(null, link)}>
                            {link.text}
                        </NavLink>
                    ))}
                </nav>
            </div>
        </>
    );
}
